import { useFormContext } from "react-hook-form";

import FormFieldSpace from "components/FormFields/Space";
import FormFieldTags from "components/FormFields/Tags";
import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";
import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";
import Input from "ds/components/Input";
import Textarea from "ds/components/Textarea";
import tooltips from "shared/Scan/tooltips";
import { ScanFormFields } from "shared/Scan/types";

import { SCHEDULE_SCAN_WIZARD_STEP_HEADERS } from "../../constants";
import { NewScanScheduleStep } from "../../types";

const NewScanScheduleStepScanDetails = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ScanFormFields>();

  return (
    <FullScreenModalBody>
      <FullScreenModalBodyHeader
        {...SCHEDULE_SCAN_WIZARD_STEP_HEADERS[NewScanScheduleStep.ScanDetails]}
      />

      <Box direction="column">
        <FormField
          label="Name"
          error={errors?.name?.message}
          tooltipInfo={tooltips.NAME}
          tooltipInfoVariant="modal"
        >
          {({ ariaInputProps }) => (
            <Input
              placeholder="Enter the name"
              error={!!errors?.name}
              {...register("name", { required: "Name field is required." })}
              {...ariaInputProps}
            />
          )}
        </FormField>

        <FormFieldSpace tooltipInfo={tooltips.SPACE} />

        <FormFieldTags
          label="Labels"
          tagName="labels"
          name="labels"
          isOptional
          tooltipInfo={tooltips.LABELS}
          tooltipInfoVariant="modal"
        />

        <FormField
          label="Description"
          isOptional
          tooltipInfo={tooltips.DESCRIPTION}
          tooltipInfoVariant="modal"
        >
          {({ ariaInputProps }) => (
            <Textarea
              placeholder="Describe the purpose of this scan"
              {...register("description")}
              {...ariaInputProps}
            />
          )}
        </FormField>
      </Box>
    </FullScreenModalBody>
  );
};

export default NewScanScheduleStepScanDetails;
